import { render, staticRenderFns } from "./InquiryAnnouncement.vue?vue&type=template&id=311a6eb8&scoped=true"
import script from "./InquiryAnnouncement.vue?vue&type=script&lang=js"
export * from "./InquiryAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./InquiryAnnouncement.vue?vue&type=style&index=0&id=311a6eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a6eb8",
  null
  
)

export default component.exports